module.exports = __webpack_public_path__ + "static/media/ranQiGuoHospital.904c3541.png";